import React from "react";
import { UserCheck, MessageSquare, Sliders, Target, CalendarClock } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
const reasons = [{
  icon: UserCheck,
  title: "Direct accountability",
  description: "One person analyses your website, decides on the strategy and carries the work forward. You have complete continuity from the initial discovery conversation through to delivery."
}, {
  icon: MessageSquare,
  title: "Personal communication",
  description: "Every recommendation is delivered in plain British English, with clear written briefs that your developers and content writers can act on immediately, backed by direct answers."
}, {
  icon: Sliders,
  title: "Tailored strategy",
  description: "Your roadmap is shaped specifically around your market, current website setup and available resources, rather than shoehorned into a rigid service package."
}, {
  icon: Target,
  title: "Commercial priorities",
  description: "I focus effort on qualified leads, customer enquiries and real sales rather than chasing impressions or vanity ranking positions that do not convert into revenue."
}, {
  icon: CalendarClock,
  title: "Flexible consultancy",
  description: "Engage freelance SEO services as an intensive one-off audit, a focused project or ongoing monthly advisory support that can scale up or down as your needs evolve."
}];
export default function WhyHire() {
  return <section id="why-hire" aria-labelledby="why-hire-heading" className="bg-muted/40 text-foreground py-20 lg:py-28 border-b border-border/40">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-14 lg:mb-16">
          <p className="text-xs sm:text-sm font-semibold uppercase tracking-wider text-primary mb-3">
            Consultancy Model
          </p>
          <h2 id="why-hire-heading" className="font-serif text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-foreground leading-tight">
            Why Hire a Freelance SEO Consultant in the UK?
          </h2>
          <p className="mt-4 text-base sm:text-lg text-muted-foreground leading-relaxed">
            In the choice between a freelance SEO consultant vs agency, engaging an independent SEO expert means your budget goes directly into strategic execution rather than overheads and management tiers. If you are assessing the right setup for your business, my guide to{" "}
            <Link to="/HireSeoConsultantPage" className="font-medium text-primary underline underline-offset-4 hover:text-primary/80 transition-colors">
              hiring an SEO consultant
            </Link>{" "}
            covers the key considerations. I also work with businesses across the country as an{" "}
            <Link to="/SeoConsultantUkPage" className="font-medium text-primary underline underline-offset-4 hover:text-primary/80 transition-colors">
              SEO consultant in the UK
            </Link>
            .
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {reasons.map((reason, i) => {
          const Icon = reason.icon;
          const isWide = i === 3 || i === 4;
          return <div key={reason.title} className={isWide ? "md:col-span-1 lg:col-span-3 lg:max-w-none" : "col-span-1"}>
                <Card className="h-full bg-card border-border shadow-xs hover:border-primary/40 transition-colors">
                  <CardHeader className="pb-3">
                    <div className="size-11 rounded-lg bg-primary/10 text-primary flex items-center justify-center mb-4">
                      <Icon className="size-5" />
                    </div>
                    <CardTitle className="font-serif text-lg sm:text-xl font-bold text-card-foreground">
                      {reason.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-sm sm:text-base text-muted-foreground leading-relaxed">
                      {reason.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}